import { render, staticRenderFns } from "./IconDiamond.vue?vue&type=template&id=61348306"
import script from "./IconDiamond.vue?vue&type=script&lang=js"
export * from "./IconDiamond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports